export abstract class BaseRouteConfig {
  public abstract get Index(): string;

  constructor(protected parentPath: string) {
    this.parentPath = parentPath;
  }

  public get Path(): string {
    return this.parentPath + this.Index;
  }
}

type IRouteParams = Record<string, string | number>;

export class ACDLRoute<T extends IRouteParams = Record<string, string | number>> {
  public Path: string = '';
  constructor(path: string) {
    this.Path = path;
  }

  public withParams(params: T): string {
    let path: string = this.Path;
    Object.keys(params).forEach(
      (k) =>
        (path = path
          .replace(`:${k}`, params[k].toString())
          .replace('?', '')
          .replace(/([^:])(\/\/+)/g, '$1/'))
    );
    return path;
  }
}
